import React from "react";

const NoResult = ({ message = "No results found.", icon = null }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px 0",
      color: "#888",
    }}
  >
    {icon ? (
      <div style={{ fontSize: 48, marginBottom: 16 }}>{icon}</div>
    ) : (
      <svg
        width="48"
        height="48"
        fill="none"
        viewBox="0 0 48 48"
        style={{ marginBottom: 16 }}
      >
        <circle
          cx="22"
          cy="22"
          r="16"
          stroke="#ccc"
          strokeWidth="2"
          fill="#f5f5f5"
        />
        <line
          x1="34"
          y1="34"
          x2="44"
          y2="44"
          stroke="#ccc"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <text
          x="22"
          y="28"
          textAnchor="middle"
          fill="#ccc"
          fontSize="16"
          fontFamily="Arial"
        >
          ?
        </text>
      </svg>
    )}
    <div style={{ fontSize: 18, fontWeight: 500 }}>{message}</div>
  </div>
);

export default NoResult;
